(() => {
  'use strict';
  if (window.FortunatoPrivacy) return;

  const keys = {
    local: ['theme-recent', 'fortunato:recent-searches'],
    session: ['recent-products', 'newsletterAppeared', 'reminderAppeared']
  };
  const newsletterName = /^newsletter-[a-zA-Z0-9_-]+$/;
  let previousPermission = null;
  let loading = false;

  const permission = () => {
    try {
      const api = window.Shopify?.customerPrivacy;
      return typeof api?.preferencesProcessingAllowed === 'function'
        ? api.preferencesProcessingAllowed() === true
        : null;
    } catch (_) {
      return null;
    }
  };

  const storage = (type) => {
    try {
      return type === 'local' ? window.localStorage : window.sessionStorage;
    } catch (_) {
      return null;
    }
  };

  const clearOptionalState = () => {
    Object.entries(keys).forEach(([type, names]) => {
      names.forEach((name) => {
        try { storage(type)?.removeItem(name); } catch (_) { /* Storage can be unavailable. */ }
      });
    });
    // Only the theme's newsletter cookies are ours to remove.
    try {
      document.cookie.split(';').forEach((entry) => {
        const name = entry.trim().split('=')[0];
        if (newsletterName.test(name)) {
          document.cookie = `${name}=; Max-Age=0; Path=/; SameSite=Lax; Secure`;
        }
      });
    } catch (_) { /* Cookies may be inaccessible in a sandboxed preview. */ }
  };

  const refresh = () => {
    const allowed = permission();
    if (allowed === false) clearOptionalState();
    if (allowed !== previousPermission) {
      previousPermission = allowed;
      document.dispatchEvent(new CustomEvent('fortunato:preferences-changed', {
        detail: { allowed: allowed === true }
      }));
    }
  };

  window.FortunatoPrivacy = {
    preferencesAllowed: () => permission() === true,
    read(type, name) {
      if (!keys[type]?.includes(name) || permission() !== true) return null;
      try { return storage(type)?.getItem(name) ?? null; } catch (_) { return null; }
    },
    write(type, name, value) {
      if (!keys[type]?.includes(name) || permission() !== true) return false;
      try {
        const target = storage(type);
        if (!target) return false;
        target.setItem(name, value);
        return true;
      } catch (_) { return false; }
    },
    readJSON(type, name, fallback) {
      try { return JSON.parse(this.read(type, name) || 'null') ?? fallback; }
      catch (_) { return fallback; }
    },
    newsletterCookie(name) {
      if (!newsletterName.test(name) || permission() !== true) return undefined;
      try { return window.Cookies?.get(name); } catch (_) { return undefined; }
    },
    saveNewsletterCookie(name, days) {
      if (!newsletterName.test(name) || permission() !== true) return;
      try {
        window.Cookies?.set(name, 'opened', {
          path: '/', expires: Math.max(1, Math.min(Number(days) || 14, 200)),
          sameSite: 'Lax', secure: true
        });
      } catch (_) { /* Dismissing a popup must work without cookie access. */ }
    }
  };

  const load = () => {
    if (permission() !== null) { refresh(); return; }
    if (loading || typeof window.Shopify?.loadFeatures !== 'function') return;
    loading = true;
    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {
        loading = false;
        refresh();
      });
    } catch (_) { loading = false; }
  };

  document.addEventListener('visitorConsentCollected', refresh);
  document.addEventListener('DOMContentLoaded', load, { once: true });
  window.addEventListener('load', load, { once: true });
  window.addEventListener('pageshow', refresh);
  load();
})();
